import AnnouncementPage from 'pages/notification/announcement/page'
import AssignConfirmPage from 'pages/notification/assignConfirm/page'
import AssignNotificationPage from 'pages/notification/assignNotification/page'
import AssignSuspentionPage from 'pages/notification/assignSuspention/page'
import NotificationDetailPage from 'pages/notification/detail/page'
import InsightPage from 'pages/notification/insight/page'
import InterviewsPage from 'pages/notification/interviews/page'
import NotificationPage from 'pages/notification/page'

export const notificationsRoutes = [
  { path: '/notification', element: <NotificationPage /> },
  { path: '/notification/:id', element: <NotificationDetailPage /> },
  {
    path: '/notification/:id/assign-confirm',
    element: <AssignConfirmPage />,
  },
  {
    path: '/notification/:id/assign-suspention',
    element: <AssignSuspentionPage />,
  },
  {
    path: '/notification/:id/assign-notification',
    element: <AssignNotificationPage />,
  },
  {
    path: '/notification/:id/announcement',
    element: <AnnouncementPage />,
  },
  {
    path: '/notification/:id/interviews',
    element: <InterviewsPage />,
  },
  {
    path: '/notification/:id/insight',
    element: <InsightPage />,
  },
]
